import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import PersonOutlineRoundedIcon from '@material-ui/icons/PersonOutlineRounded';

const useStyles = makeStyles((theme) => ({
  card: {
    marginBottom: theme.spacing(2),
    border: '1.5px solid #fed7aa',
    borderRadius: 14,
    backgroundColor: '#fff7ed',
    boxShadow: '0 2px 8px rgba(249, 115, 22, 0.08)',
  },
  cardBody: {
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(1.5, 2),
    gap: theme.spacing(1.5),
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column',
      alignItems: 'flex-start',
    },
  },
  avatar: {
    width: 42,
    height: 42,
    borderRadius: '50%',
    backgroundColor: '#ffedd5',
    color: '#ea580c',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    boxShadow: '0 2px 6px rgba(234, 88, 12, 0.12)',
  },
  avatarIcon: {
    fontSize: 22,
  },
  infoSection: {
    flex: 1,
    minWidth: 0,
  },
  nameRow: {
    display: 'flex',
    alignItems: 'center',
    gap: 4,
  },
  clientName: {
    fontSize: '0.95rem',
    fontWeight: 800,
    color: '#1e293b',
    letterSpacing: '-0.01em',
  },
  editBtn: {
    padding: 4,
    color: '#94a3b8',
    '&:hover': {
      color: '#ea580c',
    },
  },
  clientDetail: {
    fontSize: '0.82rem',
    fontWeight: 600,
    color: '#64748b',
  },
  clientAddress: {
    fontSize: '0.76rem',
    color: '#94a3b8',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  changeButton: {
    textTransform: 'none',
    borderColor: '#fdba74',
    color: '#ea580c',
    fontWeight: 700,
    borderRadius: 10,
    padding: theme.spacing(0.5, 1.75),
    fontSize: '0.82rem',
    backgroundColor: '#ffffff',
    '&:hover': {
      backgroundColor: '#ffedd5',
      borderColor: '#f97316',
    },
    [theme.breakpoints.down('xs')]: {
      alignSelf: 'flex-end',
    },
  },
}));

const ClientInfoCard = ({ client, setClient, onEdit }) => {
  const classes = useStyles();

  const handleClientChange = () => {
    setClient(null);
  };

  return (
    <Card className={classes.card} elevation={0}>
      <div className={classes.cardBody}>
        <div className={classes.avatar}>
          <PersonOutlineRoundedIcon className={classes.avatarIcon} />
        </div>
        <div className={classes.infoSection}>
          <div className={classes.nameRow}>
            <Typography className={classes.clientName}>
              {client.name}
            </Typography>
            {onEdit && (
              <IconButton
                size="small"
                title="Edit customer details"
                onClick={onEdit}
                className={classes.editBtn}
              >
                <EditOutlinedIcon fontSize="small" />
              </IconButton>
            )}
          </div>
          {client.phone && (
            <Typography className={classes.clientDetail}>
              {client.phone}
            </Typography>
          )}
          {client.address && (
            <Typography className={classes.clientAddress}>
              {client.address}
            </Typography>
          )}
        </div>
        <Button
          size="small"
          variant="outlined"
          className={classes.changeButton}
          onClick={handleClientChange}
        >
          Change
        </Button>
      </div>
    </Card>
  );
};

export default ClientInfoCard;
